import { useEffect } from "react";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import ValuePropsSection from "./components/ValuePropsSection";
import AboutSection from "./components/AboutSection";
import SolutionsSection from "./components/SolutionsSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";
import BackToTop from "@/components/base/BackToTop";
import ScrollProgress from "@/components/base/ScrollProgress";

export default function Home() {
  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -40px 0px" },
    );

    const reveals = document.querySelectorAll(".reveal");
    reveals.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <main className="min-h-screen bg-background-50">
      <ScrollProgress />
      <Navbar />
      <HeroSection />
      <AboutSection />
      <ValuePropsSection />
      <SolutionsSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
      <BackToTop />
    </main>
  );
}
